import { ConfigContext } from '@/components';
import { useContext, useEffect } from 'react';
var useDocumentTitle = function useDocumentTitle() {
    var _configState$settings3;
    var _useContext = useContext(ConfigContext), configState = _useContext.configState;
    useEffect(function () {
        var _ref, _configState$settings, _configState$settings2;
        document.title = (_ref = (_configState$settings = configState === null || configState === void 0 || (_configState$settings2 = configState.settings) === null || _configState$settings2 === void 0 ? void 0 : _configState$settings2.workspace_name) !== null && _configState$settings !== void 0 ? _configState$settings : process.env.REACT_App Store) !== null && _ref !== void 0 ? _ref : 'Common Services';
    }, [configState === null || configState === void 0 || (_configState$settings3 = configState.settings) === null || _configState$settings3 === void 0 ? void 0 : _configState$settings3.workspace_name]);
};
export default useDocumentTitle;
